import { render, staticRenderFns } from "./GestorModule.vue?vue&type=template&id=6d3842ee"
import script from "./GestorModule.vue?vue&type=script&lang=js"
export * from "./GestorModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports